import React, { useEffect, useRef, useState, Suspense, lazy } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import "./App.scss";
import Header from "./components/Header";
import Home from "./pages/Home";
import MHome from "./pages/MHome";
import SignUp from "./pages/SignUp/SignUp";
import Game from "./pages/Game";
import { isMobile } from "react-device-detect";
import MSignUp from "./pages/SignUp/MSignUp";
import AppContext from './AppContext';

const SlotScene = lazy(() => import("./pages/Slot/SlotScene"));
const MSlotScene = lazy(() => import("./pages/Slot/MSlotScene"));

function App() {
  const location = useLocation();
  const getPageClass = () => {
    const path = location.pathname;
    if (path === "/") return "home";
    if (path === "/signup") return "signup";
    if (path === "/game") return "game";
    if (path === "/slot") return "slot";
    return "not-found";
  };
  
  const navigate = useNavigate();
  useEffect(() => {
    // window.scrollTo(0, 0);
    console.log("Subscribing to game messages...");
    window.addEventListener(
      "message",
      function (event) {
        if (event?.data && typeof event.data === "string") {
          try {
            const messageFromGame = JSON.parse(event.data);
            if (messageFromGame.eventName === "afterDemo") {
              navigate("/signup");
            }
          } catch (error) {}
        }
      },
      false,
    );
  }, []);
  const currentPath = getPageClass();
  const skipHeaderOnPaths = ["game", "signup"];

  const fullscreenRef = useRef(null);
  const slotAnimationTargetRef = useRef(null);
  const slotCrystalTargetRef = useRef(null);
  const slotFSTargetRef = useRef(null);
  const slotBalanceRef = useRef(null);
  const slotOverlayRef = useRef(null);
  const [isRegistered, setIsRegistered] = useState(false);
  const [slotBalance, setSlotBalance] = useState(1000);
  const [crystalCount, setCrystalCount] = useState(0);

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      // Якщо вже в повноекранному режимі, вийти
      document.exitFullscreen();
    } else {
      // Інакше, розгорнути елемент, на який вказує ref
      fullscreenRef.current.requestFullscreen();
    }
  };

  return (
    <AppContext value={{ toggleFullscreen, slotAnimationTargetRef, slotCrystalTargetRef, slotFSTargetRef, slotBalanceRef, slotOverlayRef, isRegistered, setIsRegistered, slotBalance, setSlotBalance, crystalCount, setCrystalCount }}>
      <div
        ref={fullscreenRef}
        className={`App page-${currentPath} ${isMobile ? "mobile" : "desktop"}`}
      >
        {skipHeaderOnPaths.includes(currentPath) && isMobile ? null : (
          <Header toggleFullscreen={toggleFullscreen} />
        )}
        <Routes>
          <Route path='/' element={isMobile ? <MHome /> : <Home />} />
          <Route path='/signup' element={isMobile ? <MSignUp /> : <SignUp />} />
          <Route path='/game' element={<Game />} />
          <Route path='/slot' element={<Suspense fallback={null}>{isMobile ? <MSlotScene /> : <SlotScene />}</Suspense>} />
        </Routes>
      </div>
    </AppContext>
  );
}

export default App;
